import {
  ExpressCheckoutElement as StripeExpressCheckoutElement,
  LinkAuthenticationElement as StripeLinkAuthenticationElement,
  PaymentElement as StripePaymentElement,
} from "@stripe/react-stripe-js";
import styled, { keyframes } from "styled-components";

/* Variables */
export const GlobalStyle = styled.div`
  * {
    box-sizing: border-box;
  }
`;

export const FormContainer = styled.form`
  width: 100%;
  max-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
`;

export const Hidden = styled.div`
  display: none;
`;

export const PaymentMessage = styled.div`
  color: rgb(105, 115, 134);
  font-size: 16px;
  line-height: 20px;
  padding-top: 12px;
  text-align: center;
`;

export const LinkAuthenticationElement = styled(
  StripeLinkAuthenticationElement
)`
  margin-bottom: 24px;
`;

export const ExpressCheckoutElement = styled(StripeExpressCheckoutElement)`
  margin-bottom: 24px;
`;

export const PaymentElement = styled(StripePaymentElement)`
  margin-bottom: 24px;
`;

/* Buttons and links */
export const StripeButton = styled.button`
  background: #5469d4;
  font-family: Arial, sans-serif;
  color: #ffffff;
  border-radius: 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;

  &:hover {
    filter: contrast(115%);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

/* Spinner/processing state, errors */
const loadingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  transform: translateZ(0);

  &:before,
  &:after {
    position: absolute;
    content: "";
  }

  &:before {
    width: 10.4px;
    height: 20.4px;
    background: #5469d4;
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    transform-origin: 10.4px 10.2px;
    animation: ${loadingAnimation} 2s infinite ease 1.5s;
  }

  &:after {
    width: 10.4px;
    height: 10.2px;
    background: #5469d4;
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    transform-origin: 0px 10.2px;
    animation: ${loadingAnimation} 2s infinite ease;
  }
`;

/* Responsive styles */
export const ResponsiveForm = styled(FormContainer)`
  @media only screen and (max-width: 600px) {
    width: 80vw;
    min-width: initial;
  }
`;
